document.addEventListener('DOMContentLoaded', function () {
  const container = document.getElementById('related-products');
  if (!container) {
    return;
  }
  const productId = container.dataset.productId;
  if (!productId) {
    return;
  }
  // A bare "/recommendations/products" always resolves in the store's default language (Dutch),
  // regardless of the /de/ or /en/ page it's called from - same class of bug as the cart
  // fetches (theme.js cartUrl()) and the predictive search fetch. Shopify.routes.root already
  // carries the active locale prefix (e.g. "/de/"), so product names render in that language.
  const localeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const relatedProductsUrl =
    `${localeRoot}recommendations/products?product_id=${productId}&limit=4&intent=related&section_id=related-products`;
  fetch(relatedProductsUrl)
    .then(function (response) {
      if (!response.ok) {
        throw new Error('Failed to load related products');
      }
      return response.text();
    })
    .then(function (html) {
      if (!html.trim()) {
        return;
      }
      container.innerHTML = html;
      if (window.openSwCollapseItems) {
        window.openSwCollapseItems(container, 2);
      }
      if (window.applyIpRestriction) {
        window.applyIpRestriction();
      }
      if (window.applyRedirectNl) {
        window.applyRedirectNl();
      }
      if (window.equalizeProductCardNames) {
        window.equalizeProductCardNames();
      }
    })
    .catch(function (error) {
      console.error(
        'Related products error:',
        error
      );
    });
});